import { BonusIcon, EquityIcon, PaidTimeOffIcon, FlexibleWorkIcon, ParentalLeaveIcon, CompanyDevicesIcon, CommuterBenefitIcon, HealthInsuranceIcon, RetirementPlansIcon, WellnessProgramIcon, FamilyInsuranceIcon, TuitionAssistanceIcon, DisabilityInsuranceIcon, ProfessionalDevelopmentIcon } from 'src/assets/icons';

import { _mock } from './_mock';

// ----------------------------------------------------------------------

export const JOB_DETAILS_TABS = [
  { label: 'Job content', value: 'content' },
  { label: 'Candidates', value: 'candidates' },
];

export const JOB_SKILL_OPTIONS = [
  'UI',
  'UX',
  'Html',
  'JavaScript',
  'TypeScript',
  'Communication',
  'Problem Solving',
  'Leadership',
  'Time Management',
  'Adaptability',
  'Collaboration',
  'Creativity',
  'Critical Thinking',
  'Technical Skills',
  'Customer Service',
  'Project Management',
  'Problem Diagnosis',
];

export const JOB_SKILLS = [
  {
    id: 1,
    name: "React",
  },
  {
    id: 2,
    name: "TypeScript",
  },
  {
    id: 3,
    name: "Node.js",
  },
  {
    id: 4,
    name: "Express",
  },
  {
    id: 5,
    name: "MongoDB",
  },
  {
    id: 6,
    name: "PostgreSQL",
  }
]

export const JOB_WORKING_SCHEDULE_OPTIONS = [
  'Monday to Friday',
  'Weekend availability',
  'Day shift',
];

export const JOB_EMPLOYMENT_TYPE_OPTIONS = [
  { label: 'Full-time', value: 'Full-time' },
  { label: 'Part-time', value: 'Part-time' },
  { label: 'On demand', value: 'On demand' },
  { label: 'Negotiable', value: 'Negotiable' },
];

export const JOB_EXPERIENCE_OPTIONS = [
  { label: 'No experience', value: 'No experience' },
  { label: '1 year exp', value: '1 year exp' },
  { label: '2 year exp', value: '2 year exp' },
  { label: '> 3 year exp', value: '> 3 year exp' },
];

export const JOB_BENEFIT_OPTIONS = [
  { label: 'Free parking', value: 'Free parking' },
  { label: 'Bonus commission', value: 'Bonus commission' },
  { label: 'Travel', value: 'Travel' },
  { label: 'Device support', value: 'Device support' },
  { label: 'Health care', value: 'Health care' },
  { label: 'Training', value: 'Training' },
  { label: 'Health insurance', value: 'Health insurance' },
  { label: 'Retirement plans', value: 'Retirement plans' },
  { label: 'Paid time off', value: 'Paid time off' },
  { label: 'Flexible work schedule', value: 'Flexible work schedule' },
];

export const JOB_PERKS_BENEFITS = [
  {
    key: "health_insurance",
    value: "Health Insurance",
    description: "Covers medical, dental, and vision costs for employees.",
    icon: HealthInsuranceIcon
  },
  {
    key: "paid_time_off",
    value: "Paid Time Off (PTO)",
    description: "Vacation, sick leave, and personal days included.",
    icon: PaidTimeOffIcon
  },
  {
    key: "retirement_plans",
    value: "Retirement Plans",
    description: "401(k) and other savings plans with possible employer match.",
    icon: RetirementPlansIcon
  },
  {
    key: "life_insurance",
    value: "Life Insurance",
    description: "Provides a payout to beneficiaries in case of death.",
    icon: FamilyInsuranceIcon
  },
  {
    key: "disability_insurance",
    value: "Disability Insurance",
    description: "Replaces income during illness, injury, or disability.",
    icon: DisabilityInsuranceIcon
  },
  {
    key: "bonuses_profit_sharing",
    value: "Bonuses & Profit Sharing",
    description: "Performance or profit-based financial rewards.",
    icon: BonusIcon
  },
  {
    key: "stock_options",
    value: "Stock Options / Equity",
    description: "Ownership opportunities in company shares or equity.",
    icon: EquityIcon
  },
  {
    key: "flexible_work",
    value: "Flexible Work Arrangements",
    description: "Remote, hybrid, or flexible scheduling options.",
    icon: FlexibleWorkIcon
  },
  {
    key: "professional_development",
    value: "Professional Development",
    description: "Funds for education, training, and certifications.",
    icon: ProfessionalDevelopmentIcon
  },
  {
    key: "employee_assistance",
    value: "Employee Assistance Programs (EAPs)",
    description: "Counseling and support for personal or mental health issues.",
    icon: TuitionAssistanceIcon
  },
  {
    key: "parental_leave",
    value: "Parental Leave",
    description: "Paid maternity, paternity, or family caregiving leave.",
    icon: ParentalLeaveIcon
  },
  {
    key: "wellness_programs",
    value: "Wellness Programs",
    description: "Gym, fitness, or mental health support benefits.",
    icon: WellnessProgramIcon
  },
  {
    key: "commuter_benefits",
    value: "Commuter Benefits",
    description: "Subsidies for transit, parking, or company transport.",
    icon: CommuterBenefitIcon
  },
  {
    key: "company_devices",
    value: "Company Devices & Tools",
    description: "Work laptops, phones, and essential software provided.",
    icon: CompanyDevicesIcon
  },
  {
    key: "tuition_assistance",
    value: "Tuition Assistance",
    description: "Financial help for continuing education or courses.",
    icon: TuitionAssistanceIcon
  }
];

export const JOB_PUBLISH_OPTIONS = [
  { label: 'Published', value: 'published' },
  { label: 'Draft', value: 'draft' },
];

export const JOB_SORT_OPTIONS = [
  { label: 'Latest', value: 'latest' },
  { label: 'Popular', value: 'popular' },
  { label: 'Oldest', value: 'oldest' },
];

const CANDIDATES = Array.from({ length: 12 }, (_, index) => ({
  id: _mock.id(index),
  role: _mock.role(index),
  name: _mock.fullName(index),
  avatarUrl: _mock.image.avatar(index),
}));

const CONTENT = `
<h6>Job description</h6>

<p>Occaecati est et illo quibusdam accusamus qui. Incidunt aut et molestiae ut facere aut. Est quidem iusto praesentium excepturi harum nihil tenetur facilis. Ut omnis voluptates nihil accusantium doloribus eaque debitis.</p>

<h6>Key responsibilities</h6>

<ul>
  <li>Working with agency for design drawing detail, quotation and local production.</li>
  <li>Produce window displays, signs, interior displays, floor plans and special promotions displays.</li>
  <li>Change displays to promote new product launches and reflect festive or seasonal themes.</li>
  <li>Planning and executing the open/renovation/ closing store procedure.</li>
  <li>Follow‐up store maintenance procedure and keep updating SKU In &amp; Out.</li>
  <li>Monitor costs and work within budget.</li>
  <li>Liaise with suppliers and source elements.</li>
</ul>

<h6>Why You'll love working here</h6>

<ul>
  <li>Working with agency for design drawing detail, quotation and local production.</li>
  <li>Produce window displays, signs, interior displays, floor plans and special promotions displays.</li>
  <li>Change displays to promote new product launches and reflect festive or seasonal themes.</li>
  <li>Planning and executing the open/renovation/ closing store procedure.</li>
  <li>Follow‐up store maintenance procedure and keep updating SKU In &amp; Out.</li>
  <li>Monitor costs and work within budget.</li>
  <li>Liaise with suppliers and source elements.</li>
</ul>
`;

export const _jobs = Array.from({ length: 12 }, (_, index) => {
  const publish = index % 3 ? 'published' : 'draft';

  const salary = {
    type: (index % 5 && 'Custom') || 'Hourly',
    price: _mock.number.price(index),
    negotiable: _mock.boolean(index),
  };

  const benefits = JOB_BENEFIT_OPTIONS.slice(0, 3).map((option) => option.label);

  const experience =
    JOB_EXPERIENCE_OPTIONS.map((option) => option.label)[index] || JOB_EXPERIENCE_OPTIONS[1].label;

  const employmentTypes = (index % 2 && ['Part-time']) ||
    (index % 3 && ['On demand']) ||
    (index % 4 && ['Negotiable']) || ['Full-time'];

  const company = {
    name: _mock.companyNames(index),
    logo: _mock.image.company(index),
    phoneNumber: _mock.phoneNumber(index),
    fullAddress: _mock.fullAddress(index),
  };

  return {
    id: _mock.id(index),
    salary,
    publish,
    company,
    benefits,
    experience,
    employmentTypes,
    content: CONTENT,
    candidates: CANDIDATES,
    role: _mock.role(index),
    title: _mock.jobTitle(index),
    createdAt: _mock.time(index),
    expiredDate: _mock.time(index),
    skills: JOB_SKILL_OPTIONS.slice(0, 3),
    totalViews: _mock.number.nativeL(index),
    locations: [_mock.countryNames(1), _mock.countryNames(2)],
    workingSchedule: JOB_WORKING_SCHEDULE_OPTIONS.slice(0, 2),
  };
});
